import styled, { css } from 'styled-components';
import { TypographyTextProps } from './types';
import {
	FULL_SLOT,
	MAIN_TEXT_COLOR,
	SUCCESS_COLOR,
	TEXT_COLOR,
} from 'shared/consts';
import { NEUTRAL_COLOR } from 'shared/consts/styleValues';

export const TypographyText = styled.div<TypographyTextProps>`
	font-family: Open Sans;
  line-height: 1;
	font-size: ${props => {
		switch (props.$mode) {
			case 'smaller':
				return '12px';
			case 'small':
				return '14px';
			case 'medium':
				return '16px';
			case 'large':
				return '18px';
			case 'h3':
				return '20px';
			case 'h2':
				return '22px';
			case 'h1':
				return '34px';
			default:
				return '16px';
		}
	}};

	font-weight: ${props => (props.$isBold ? '600' : '400')};
	white-space: ${props => props.$whiteSpace || 'initial'};
	word-break: ${props => props.$wordBreak || 'initial'};
	cursor: ${props => (props.$pointer ? 'pointer' : 'initial')};
	color: ${props => {
		switch (props.$colorVariant) {
			case 'main':
				return MAIN_TEXT_COLOR;
			case 'danger':
				return FULL_SLOT;
			case 'neutral':
				return NEUTRAL_COLOR;
			case 'success':
				return SUCCESS_COLOR;
			case 'white':
				return 'white';
			case 'inherit':
				return 'inherit';
			case 'default':
				return TEXT_COLOR;
			default:
				return TEXT_COLOR;
		}
	}};

	margin: 0;

	${props =>
		props.$textAlignCenter &&
		css`
			text-align: center;
	`};

	${props =>
		props.$truncate &&
		css`
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
	`}

  ${props=>
    props.$isMixDiff && css`
      mix-blend-mode: difference;
    `
  }

	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;
`;

export const TypographyContainer = styled.div<{ $marginBottom?: string }>`
	margin-bottom: ${props => props.$marginBottom || '6px'};
	margin-left: 3px;
`;
